import { sva } from "@stubhub/broadway-foundation/css";

export const dayContextTagSlots = ["root", "dot", "label"] as const;

export const dayContextTagRecipe = sva({
  slots: dayContextTagSlots,
  className: "dayContextTag",
  base: {
    dot: {
      display: "inline-block",
      width: "primitives.75",
      height: "primitives.75",
      borderStartRadius: "full",
      borderEndRadius: "full",
      backgroundColor: "text.onFill",
      flexShrink: "0",
    },
    label: {
      color: "text.onFill",
      lineHeight: "[1]",
    },
  },
  variants: {
    device: {
      desktop: {
        root: {
          position: "absolute",
          insetBlockStart: "primitives.0",
          insetInlineEnd: "primitives.200",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          columnGap: "primitives.50",
          paddingBlock: "[3px]",
          paddingInline: "[10px]",
          borderEndStartRadius: "primitives.75",
          borderEndEndRadius: "primitives.75",
        },
        label: {
          fontSize: "[10px]",
          fontWeight: "bold",
        },
      },
      mobile: {
        root: {
          display: "inline-flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          columnGap: "primitives.75",
          paddingBlock: "primitives.50",
          paddingInline: "primitives.100",
          marginBlockEnd: "primitives.50",
          borderStartRadius: "primitives.250",
          borderEndRadius: "primitives.250",
        },
        label: {
          fontSize: "primitives.300",
          fontWeight: "medium",
        },
      },
    },
    day: {
      today: {
        root: {
          backgroundColor: "bg.fill.brand",
        },
      },
      tomorrow: {
        root: {
          backgroundColor: "bg.dark",
        },
      },
    },
  },
  defaultVariants: {
    device: "desktop",
    day: "today",
  },
});
